import { ServiceObject } from "app/models/serviceObject";
import { ServiceArea } from "./serviceArea";

export class Location extends ServiceObject  {

}



// WEBPACK FOOTER //
// /app/SPA/src/app/models/location.ts